export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const validateEmail = (email: string): string | undefined => {
  if (!email) {
    return 'Email is required'
  }
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address'
  }
  return undefined
}

export const validatePassword = (password: string): string | undefined => {
  if (!password) {
    return 'Password is required'
  }
  if (password.length < 8) {
    return 'Password must be at least 8 characters long'
  }
  if (!/(?=.*[a-z])/.test(password)) {
    return 'Password must contain at least one lowercase letter'
  }
  if (!/(?=.*[A-Z])/.test(password)) {
    return 'Password must contain at least one uppercase letter'
  }
  if (!/(?=.*\d)/.test(password)) {
    return 'Password must contain at least one number'
  }
  return undefined
}

export const validateConfirmPassword = (
  password: string,
  confirmPassword: string
): string | undefined => {
  if (!confirmPassword) {
    return 'Please confirm your password'
  }
  if (password !== confirmPassword) {
    return 'Passwords do not match'
  }
  return undefined
}

export const getPasswordStrength = (
  password: string
): {
  score: number
  label: string
  color: string
} => {
  let score = 0

  if (password.length >= 8) score++
  if (/(?=.*[a-z])/.test(password)) score++
  if (/(?=.*[A-Z])/.test(password)) score++
  if (/(?=.*\d)/.test(password)) score++
  if (/(?=.*[!@#$%^&*])/.test(password)) score++

  if (score <= 1) {
    return { score, label: 'Weak', color: '#ef4444' }
  } else if (score <= 3) {
    return { score, label: 'Fair', color: '#f59e0b' }
  } else if (score <= 4) {
    return { score, label: 'Good', color: '#10b981' }
  } else {
    return { score, label: 'Strong', color: '#059669' }
  }
}
